import { AgentMessageContainer } from "@/components/Chat/AgentMessageStyles.ts"
import { MessageText } from "@/components/Chat/MessageStyles.ts"
import { getLogger } from "@/lib/logging.ts"

import type { ChatMessageModel } from "@/components/Chat/ChatModel.ts"
import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"

const log = getLogger("Message")

export const UnknownMessage = (props: {
  message?: ChatMessageModel
}) => {
  if (import.meta.env.PROD) {
    return null
  }

  log.warn("Unhandled message content", (props.message?.content as AiChatMessageContent).className)

  return (
    <AgentMessageContainer isActive={props.message?.active}>
      <MessageText>
        Message is unavailable or unsupported
      </MessageText>
    </AgentMessageContainer>
  )
}